import {
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Description as DescriptionIcon,
    Edit as EditIcon,
    FilterList,
    FirstPage,
    LastPage,
    Remove,
    SaveAlt,
    Search,
    ViewColumn,
} from '@material-ui/icons';
import * as React from 'react';

const tableIcons: object = {
    // @ts-ignore
    Add: React.forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    // @ts-ignore
    Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
    // @ts-ignore
    Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    // @ts-ignore
    Delete: React.forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    // @ts-ignore
    DetailPanel: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    // @ts-ignore
    Edit: React.forwardRef((props, ref) => <EditIcon {...props} ref={ref} />),
    // @ts-ignore
    Export: React.forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    // @ts-ignore
    Filter: React.forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    // @ts-ignore
    FirstPage: React.forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    // @ts-ignore
    LastPage: React.forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    // @ts-ignore
    NextPage: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    // @ts-ignore
    PreviousPage: React.forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    // @ts-ignore
    ResetSearch: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    // @ts-ignore
    Search: React.forwardRef((props, ref) => <Search {...props} ref={ref} />),
    // @ts-ignore
    SortArrow: React.forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    // @ts-ignore
    ThirdStateCheck: React.forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    // @ts-ignore
    ViewColumn: React.forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    // @ts-ignore
    Description: React.forwardRef((props, ref) => <DescriptionIcon {...props} ref={ref} />),
};

export default tableIcons;